var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drug_sold_stat_block" }, [
    _vm.invoices && _vm.invoices.length
      ? _c(
          "div",
          { staticClass: "info_block mb-1" },
          [
            _c("p", [_vm._v("Накладные поступления")]),
            _vm._v(" "),
            _vm._l(_vm.invoices, function (i) {
              return _c("p", [
                !_vm.inModal
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-info newWindowBtn",
                        on: {
                          click: function ($event) {
                            return _vm.showInvoice(i.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                    )
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(i.id) + " "),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.printDate(i.delivery_date, "DD.MM.YYYY"))),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(Math.round(i.qty * 100) / 100) +
                    " x " +
                    _vm._s(Math.round(i.price * 100) / 100) +
                    "\n      (" +
                    _vm._s(Math.round(i.income_price * 100) / 100) +
                    ")\n      " +
                    _vm._s(_vm.$AllCurrencies[i.currency_id]?.currency) +
                    "\n      "
                ),
                i.status === 5
                  ? _c("span", { staticClass: "badge badge-info" }, [
                      _vm._v("рез."),
                    ])
                  : _vm._e(),
              ])
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.ordersStat
      ? _c(
          "div",
          { staticClass: "info_block mb-1" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("p", [
              _vm._v("Выполненые: "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    Object.keys(_vm.ordersStat.closed?.orders_num || {}).length
                  )
                ),
              ]),
              _vm._v("\n      (" + _vm._s(_vm.ordersStat.closed?.drugs) + ")"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("В работе: "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    Object.keys(_vm.ordersStat.progress?.orders_num || {})
                      .length
                  )
                ),
              ]),
              _vm._v(
                "\n      (" + _vm._s(_vm.ordersStat.progress?.drugs) + ")"
              ),
            ]),
            _vm._v(" "),
            Object.keys(_vm.ordersStat.rejected?.orders_num || {}).length
              ? [
                  _c("p", [
                    _vm._v("Отказы за "),
                    _c("strong", [_vm._v("3")]),
                    _vm._v(" мес. "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.getRejectedOrders(true, 90).length +
                            _vm.getRejectedOrders(false, 90).length
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("("),
                      _c("span", [
                        _vm._v("М "),
                        _c(
                          "strong",
                          [
                            _vm.getRejectedOrders(true, 90).length
                              ? [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.openInNewPage("searchOrder", {
                                            ordersId: _vm.getRejectedOrders(
                                              true,
                                              90
                                            ),
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.getRejectedOrders(true, 90)
                                              .length
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              : [_vm._v("0")],
                          ],
                          2
                        ),
                        _vm._v("\n          К "),
                        _c(
                          "strong",
                          [
                            _vm.getRejectedOrders(false, 90).length
                              ? [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.openInNewPage("searchOrder", {
                                            ordersId: _vm.getRejectedOrders(
                                              false,
                                              90
                                            ),
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.getRejectedOrders(false, 90)
                                              .length
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              : [_vm._v("0")],
                          ],
                          2
                        ),
                        _vm._v("\n          )"),
                      ]),
                    ]),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.getRejectedOrders(true, 30).length ||
            _vm.getRejectedOrders(false, 30).length
              ? [
                  _c("p", [
                    _vm._v("Отказы за "),
                    _c("strong", [_vm._v("30")]),
                    _vm._v(" дн.\n        "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.getRejectedOrders(true, 30).length +
                            _vm.getRejectedOrders(false, 30).length
                        )
                      ),
                    ]),
                    _vm._v("\n        (М "),
                    _c(
                      "strong",
                      [
                        _vm.getRejectedOrders(true, 30).length
                          ? [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.openInNewPage("searchOrder", {
                                        ordersId: _vm.getRejectedOrders(
                                          true,
                                          30
                                        ),
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getRejectedOrders(true, 30).length
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          : [_vm._v("0")],
                      ],
                      2
                    ),
                    _vm._v("\n        К "),
                    _c(
                      "strong",
                      [
                        _vm.getRejectedOrders(false, 30).length
                          ? [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.openInNewPage("searchOrder", {
                                        ordersId: _vm.getRejectedOrders(
                                          false,
                                          30
                                        ),
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getRejectedOrders(false, 30).length
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          : [_vm._v("0")],
                      ],
                      2
                    ),
                    _vm._v(")\n      "),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.soldData && Object.keys(_vm.soldData).length
      ? _c("div", { staticClass: "info_block mb-1 flex flex_gap_10" }, [
          _c(
            "div",
            [
              _c("p", [
                _vm._v("Продажи за периоды в 30 дней "),
                +_vm.drug.pack_set !== 1
                  ? _c("span", [_vm._v("(в зав.уп.)")])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm._l(_vm.monthsList, function (monthNum, i) {
                return _c("p", [
                  _vm._v(_vm._s(_vm.monthNames[monthNum]) + ":\n        "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.soldData[i + 1]?.total ?? 0)),
                  ]),
                  _vm._v(" "),
                  i === 0 && _vm.ordersStat?.progress?.drugs
                    ? _c("span", [
                        _vm._v("( +\n            "),
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.openInNewPage("searchOrder", {
                                  ordersId: Object.keys(
                                    _vm.ordersStat.progress?.orders_num || {}
                                  ),
                                })
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.ordersStat.progress.drugs))]
                        ),
                        _vm._v(")"),
                      ])
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.getSoldDataTrend(_vm.soldData)),
                },
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pl-1 border-left" },
            [
              _c("SoldStatisticsDiff", {
                attrs: {
                  drug: _vm.inModal ? _vm.drug : null,
                  soldData: _vm.soldDiffData,
                },
              }),
            ],
            1
          ),
        ])
      : _c(
          "div",
          [
            _vm.ordersStat && _vm.ordersStat?.progress?.drugs
              ? [
                  _vm._v("\n      Бронь: "),
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.openInNewPage("searchOrder", {
                            ordersId: Object.keys(
                              _vm.ordersStat.progress?.orders_num || {}
                            ),
                          })
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.ordersStat.progress.drugs))]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Статистика за "),
      _c("strong", [_vm._v("6")]),
      _vm._v(" мес."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }